<div class="alert" [ngClass]="className">
  <ng-content></ng-content>
</div>
